// @flow
import PlainLabel, { type Props } from './plain-label';


export default PlainLabel;

export type { Props };
